import { effects } from 'redux-saga'
import moment from 'moment'

import { refreshCredentials } from '../../modules/authentication'
import timeout from '../../../util/timeout'

/**
 * Sets a timeout that will request a credential refresh when the expiry of the HMAC is
 * ~60 seconds away.
 *
 * Will always abort the previous waiting period when we receive new credentials.
 */
export default function* updateSaga() {
  const state = yield effects.select()
  const expiry = state.authentication.getIn(['hmac', 'expires'])
  if (!expiry || expiry.isBefore()) {
    return
  }

  const toExpiry = Math.max(expiry.diff() - 60000, 0)

  /* istanbul ignore next */
  // eslint-disable-next-line no-console,no-unused-expressions
  __DEBUG__ && console.log('Scheduled credential refresh for ', moment().add(toExpiry).format())

  yield effects.call(timeout, toExpiry)
  yield effects.put.resolve(refreshCredentials())
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/authentication/update.js